'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

var RightArrowCircledOutline = function RightArrowCircledOutline(_ref) {
  var className = _ref.className,
      _ref$color = _ref.color,
      color = _ref$color === undefined ? 'currentColor' : _ref$color;
  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      focusable: 'false',
      'aria-hidden': true,
      className: 'icon-svg-right-arrow-circled-outline ' + className,
      preserveAspectRatio: 'xMinYMin meet',
      viewBox: '0 0 16 16' },
    _react2.default.createElement('path', {
      fill: color,
      fillRule: 'evenodd',
      d: 'M15,8 C15,9.26075283 14.6848117,10.4274194 14.0544355,11.5 C13.4240593,12.5725806 12.5725806,13.4240593 11.5,14.0544355 C10.4274194,14.6848117 9.26075283,15 8,15 C6.73924717,15 5.57258065,14.6848117 4.5,14.0544355 C3.42741935,13.4240593 2.57594072,12.5725806 1.94556452,11.5 C1.31518832,10.4274194 1,9.26075283 1,8 C1,6.73924717 1.31518832,5.57258065 1.94556452,4.5 C2.57594072,3.42741935 3.42741935,2.57594072 4.5,1.94556452 C5.57258065,1.31518832 6.73924717,1 8,1 C9.26075283,1 10.4274194,1.31518832 11.5,1.94556452 C12.5725806,2.57594072 13.4240593,3.42741935 14.0544355,4.5 C14.6848117,5.57258065 15,6.73924717 15,8 Z M2.35483871,8 C2.35483871,9.01612903 2.60887097,9.9569891 3.11693548,10.8225806 C3.625,11.6881722 4.31182781,12.375 5.17741935,12.8830645 C6.0430109,13.391129 6.98387097,13.6451613 8,13.6451613 C9.01612903,13.6451613 9.9569891,13.391129 10.8225806,12.8830645 C11.6881722,12.375 12.375,11.6881722 12.8830645,10.8225806 C13.391129,9.9569891 13.6451613,9.01612903 13.6451613,8 C13.6451613,6.98387097 13.391129,6.0430109 12.8830645,5.17741935 C12.375,4.31182781 11.6881722,3.625 10.8225806,3.11693548 C9.9569891,2.60887097 9.01612903,2.35483871 8,2.35483871 C6.98387097,2.35483871 6.0430109,2.60887097 5.17741935,3.11693548 C4.31182781,3.625 3.625,4.31182781 3.11693548,5.17741935 C2.60887097,6.0430109 2.35483871,6.98387097 2.35483871,8 Z M4.38709677,7.43548387 C4.38709677,7.34139799 4.42002703,7.26142459 4.4858871,7.19556452 C4.55174717,7.12970444 4.63172057,7.09677419 4.72580645,7.09677419 L8,7.09677419 L8,5.20564516 C8,5.05510767 8.07056452,4.9516129 8.21169355,4.89516129 C8.35282258,4.83870968 8.47043025,4.85752703 8.56451613,4.9516129 L11.3870968,7.74596774 C11.4435484,7.8212367 11.4717742,7.90591412 11.4717742,8 C11.4717742,8.09408588 11.4435484,8.1787633 11.3870968,8.25403226 L8.59274194,11.0201613 C8.47983871,11.1330645 8.35282258,11.1612903 8.21169355,11.1048387 C8.07056452,11.0483871 8,10.9448923 8,10.7943548 L8,8.90322581 L4.72580645,8.90322581 C4.63172057,8.90322581 4.55174717,8.87029556 4.4858871,8.80443548 C4.42002703,8.73857541 4.38709677,8.65860201 4.38709677,8.56451613 L4.38709677,7.43548387 Z' })
  );
};

RightArrowCircledOutline.propTypes = _bcPropTypes.iconShape;

exports.default = RightArrowCircledOutline;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/RightArrowCircledOutline/RightArrowCircledOutline.js
// module id = 309
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15